import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ACTION_STATUS_ACTIVE, ACTION_STATUS_DISABLED_BY_FAILURE, ACTION_STATUS_WAITING_SUB_ACTIONS } from './constants';

export const StatusColor = {
  NEW: '#07d4f5',
  ACTIVE: '#17a2b8',
  DONE: '#00aa00',
  FAILED: '#ff4400',
  MIA: '',
  EXPIRED: 'black',
  WAITING_SUB_ACTION: '#2007ec',
  WAITING_EXECUTOR_ACTION: '#2007ec',
  REJECTED: '#888888',
  INCOMPLETE: '#1ed08e',
  POST_RESTARTING: '#e8a100',
  WAITING_RESTART: '#e8a100',
  DISABLED_BY_FAILURE: '#d63c04',
};

export const StatusCell = ({value, className, row, onShowProgress, onClickShowActiveActions, onClickShowFailedActions, onClickStatusAction, onRestartAction}) => {
  const {showProgress, progress} = row;
  const allowClickByProgress = !!onShowProgress && value === ACTION_STATUS_ACTIVE;
  const isDisabledByFailure = value === ACTION_STATUS_DISABLED_BY_FAILURE;
  const isWaitingSubActions = value === ACTION_STATUS_WAITING_SUB_ACTIONS;
  const showProgressBar  = !!showProgress && value !== 'FAILED' && value !== 'DONE';
  const isFailed = value === 'FAILED';

  let loadActionsBtn = null;
  let actionsTitle = null;
  if (isWaitingSubActions) {
    loadActionsBtn = <span className='span-clickable' onClick={() => onClickShowActiveActions(row)}>View active action(s)</span>;
    actionsTitle = 'Active Action(s)';
  }
  if (isDisabledByFailure) {
    loadActionsBtn = <span className='span-clickable' onClick={() => onClickShowFailedActions(row)}>View failed action(s)</span>;
    actionsTitle = 'Failed Action(s)';
  }

  let actionsList = null;
  if (row.actions) {
    if (row.actions.length > 0) {
      actionsList = row.actions.map(a => {
        return <div key={a.actionID}>{a.actionType} (<span className='span-clickable' onClick={() => onClickStatusAction(row, a)}>{a.actionID}</span>)</div>;
      });
    } else {
      actionsList = <div>No actions</div>;
    }
  }

  let showLoadActionsBtn = loadActionsBtn && (row.actions === undefined || (row.actions && row.actions.length === 0));

  return (
    <StyledCell>
      <div
        className='status'
        style={StatusColor[value] ? {backgroundColor: StatusColor[value]} : undefined}
      >
        {value}
      </div>
      {isFailed && <div><span className='span-clickable' onClick={() => onRestartAction(row)}>Restart</span></div>}
      {showLoadActionsBtn && <div>{loadActionsBtn}</div>}
      {actionsList && <div><span>{actionsTitle}:</span>{actionsList}</div>}
      {showProgressBar &&
        <div
          className={`progress${allowClickByProgress ? '' : ' disabled'}`}
          onClick={allowClickByProgress ? () => onShowProgress(row) : undefined}
          title={`Progress: ${progress || 0}%`}
        >
          <div
            className="progress-bar"
            style={{background: StatusColor.DONE, width: `${progress || 0}%`}}
          >
            {progress >= 25 ? `${progress}%` : ''}
          </div>
        </div>
      }
    </StyledCell>
  );
};

const StyledCell = styled.td`
  .status {
    background-color: #343a40;
    border: 1px solid transparent;
    border-radius: 5px;
    color: #fff;
    display: inline-block;
    margin: 0 3px 3px 0;
    padding: 0 4px;
  }
  .status_clickable {
    cursor: pointer;
  }
  .progress {
    min-width: 50px;
    width: 100%;
    height: 20px;
    margin: 20px 0 0;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgb(0 0 0 / 10%);
    cursor: pointer;
    .progress-bar {
      float: left;
      width: 0%;
      height: 100%;
      font-size: 12px;
      line-height: 20px;
      color: #fff;
      text-align: center;
      background-color: #337ab7;
      box-shadow: inset 0 -1px 0 rgb(0 0 0 / 15%);
      transition: width .6s ease;
    }
    &.disabled {
      cursor: default;
    }
  }
  .span-clickable {
    color: #007bff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

StatusCell.propTypes = {
  value: PropTypes.any,
  className: PropTypes.string,
  row: PropTypes.object,
  onShowProgress: PropTypes.func,
  onRestartAction: PropTypes.func,
};
